// import { createSelector, createIdSelector } from 'redux-views'

export const getUid = state => state.firebase.auth.uid
